import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useQuoteCart } from "@/context/QuoteCartContext";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/catalog", label: "Dessert Collection" },
  { to: "/sample-box", label: "Sample Box" },
  { to: "/wholesale", label: "B2B Solutions" },
  { to: "/partnerships", label: "Partnerships" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const { totalQty, setOpen } = useQuoteCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/90 border-b border-brand-line"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-24 flex items-center justify-between gap-6">
        <Link to="/" data-testid="brand-logo" className="flex items-center group">
          <img
            src="https://customer-assets.emergentagent.com/job_bakery-b2b/artifacts/klxy49l5_Karpatka.png"
            alt="Cake World — Every occasion needs a sweet touch"
            className="h-20 w-auto object-contain group-hover:scale-105 transition-transform"
          />
        </Link>

        <nav className="hidden xl:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) =>
                `text-sm font-ui tracking-wide transition-colors border-b-2 pb-1 ${
                  isActive
                    ? "text-brand-red border-brand-red font-semibold"
                    : "text-brand-ink border-transparent hover:text-brand-red"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="open-quote-cart"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 px-5 h-11 rounded-full bg-brand-red text-white text-sm font-ui font-semibold hover:bg-brand-redDark active:scale-95 transition"
          >
            <ShoppingBag className="w-4 h-4" />
            <span className="hidden sm:inline">Quote Cart</span>
            {totalQty > 0 && (
              <span
                data-testid="quote-cart-badge"
                className="absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full bg-brand-pink text-brand-ink text-[11px] font-bold flex items-center justify-center"
              >
                {totalQty}
              </span>
            )}
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="xl:hidden w-10 h-10 grid place-items-center rounded-full border border-brand-line text-brand-ink"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="xl:hidden border-t border-brand-line bg-white" data-testid="mobile-menu">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setMobileOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-3 py-3 rounded-lg text-sm font-ui ${
                  loc.pathname === n.to ? "bg-brand-pinkLight text-brand-red font-semibold" : "text-brand-ink"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
